function removeLineBreaks(string) {
  return string.replaceAll(/\n/g, '');
}

export { removeLineBreaks };
